// @flow
import React, { useContext, Fragment } from 'react';
import { Heading, Icons, Inline } from 'sarsaparilla';
import { uniqueId } from 'lodash';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout'

type RequirementsPropTypes = {
    hasTypeRequirement?: boolean,
    hasSizeRequirement?: boolean,
    hasStartingAreaRequirement?: boolean,
    customRequirements?: string[],
};
function Requirements({
    hasTypeRequirement,
    hasSizeRequirement,
    hasStartingAreaRequirement,
    customRequirements,
}: RequirementsPropTypes) {
    const Type = <span>a <strong>Permit Type</strong></span>;
    const Group = <span>a <strong>Group Size</strong></span>;
    const StartingArea = <span>a <strong>Starting Area</strong></span>;
    const requirements = [];

    if (hasTypeRequirement) {
        requirements.push({ key: 1, content: Type })
    }

    if (hasSizeRequirement) {
        requirements.push({ key: 2, content: Group })
    }

    if (hasStartingAreaRequirement) {
        requirements.push({ key: 3, content: StartingArea })
    }

    customRequirements.forEach((text) => {
        requirements.push({
            key: uniqueId(),
            content: <span>a <strong>{text}</strong></span>
        })
    });

    if (requirements.length > 2) {
        const allButLast = requirements.slice(0, requirements.length - 1);

        return (
            <React.Fragment>
                {allButLast.map((item) => {
                    return <span key={item.key}>{item.content}, </span>
                })}
                <span> and {requirements[requirements.length - 1].content}</span>
            </React.Fragment>
        )
    }

    if (requirements.length === 2) {
        return (
            <React.Fragment>
                {requirements[0].content} and {requirements[1].content}
            </React.Fragment>
        )
    }

    return requirements[0].content;
}

type PropTypes = RequirementsPropTypes & {
    divisionType: string,
};
const InformationRequired = ({
    divisionType,
    hasTypeRequirement = false,
    hasSizeRequirement = false,
    hasStartingAreaRequirement = false,
    customRequirements = []
}: PropTypes) => {
    const { isMobileApp } = useContext(LayoutControlContext);
    const hasARequirement = hasTypeRequirement || hasSizeRequirement || hasStartingAreaRequirement || !!customRequirements?.length;
    if(!hasARequirement) return null;

    const WrapElement = isMobileApp ? Inline : Fragment;
    const wrapElementProps = isMobileApp ? {
        alignX: "center",
        className: "mb-2",
    } : { }

    return (
        <div className="permit-information-required">
            <div className="permit-information-required-wrap">
                <WrapElement {...wrapElementProps}>
                    <Icons.IconInfoOutline size={isMobileApp ? 'md' : 'xl'} />
                    <Heading headingLevel={2} appearance="h5" className="permit-information-required-heading">
                        Information Required
                    </Heading>
                </WrapElement>
                <p>
                    Please enter{' '}
                    <Requirements
                        hasTypeRequirement={hasTypeRequirement}
                        hasSizeRequirement={hasSizeRequirement}
                        customRequirements={customRequirements}
                        hasStartingAreaRequirement={hasStartingAreaRequirement} /> {' '}
                    to view available {divisionType.toLowerCase()} for your trip.
                </p>
            </div>
        </div>
    );
}

export default InformationRequired;
